import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PhxButtonSelectOption, PhxButtonSelectIconColor } from './phx-button-select.types';
import { ChevronDown } from '../icon/icon-map';
import { PhxSelectOption, PhxSelectValue } from '../select/select.types';
import mixinDisabled from '../../mixins/disabled';
import { phxWebStyleTokens } from '../../styles/phx-tokens';
import { upperFirst } from '../../utils';
import { PhxButtonSize } from '../button/phx-button.component';
import { PHX_SIZE } from '../../constants';

const baseButtonMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'phx-button-select',
  templateUrl: './phx-button-select.component.html',
  styleUrls: ['./phx-button-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['disabled'],
  host: { class: 'phx-button-select' },
})
export class PhxButtonSelectComponent extends baseButtonMixin implements OnChanges {
  @Input() phxOptions: PhxButtonSelectOption[] = [];
  @Input() phxPlaceholder: string;
  @Input() phxDropdownWidth: number = null;
  @Input() phxSelected: PhxSelectValue;
  @Input() phxSize: PhxButtonSize = PHX_SIZE.MD;

  @Output() phxSelectedChange: EventEmitter<PhxSelectValue> = new EventEmitter<PhxSelectValue>();

  public selectedOption: PhxSelectOption;
  public readonly ChevronDownIcon: string = ChevronDown;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { phxSelected } = changes;

    if (phxSelected && phxSelected.previousValue !== phxSelected.currentValue) {
      this.selectedOption = this.phxOptions.find((opt) => opt.value === phxSelected.currentValue);
    }
  }

  public updateSelectedOption(option: PhxSelectOption | PhxSelectOption[]) {
    this.selectedOption = option as PhxSelectOption;
    this.phxSelectedChange.emit(this.selectedOption.value);
  }

  public getIconColor(colorType: PhxButtonSelectIconColor = 'active', isDisabled: boolean): string {
    if (isDisabled) return phxWebStyleTokens.colorContentInactive;
    return phxWebStyleTokens[`colorContent${upperFirst(colorType)}`];
  }
}
